// React
import React from "react";

// Third party imports
import { useLocation, useNavigate } from "react-router-dom";
import { PROTECTED_ROUTES } from "routes";

// Components
import AnimationWrapper from "components/AnimationWrapper";

export default function PublicRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isCompleteProfile = location.pathname.startsWith("/complete-registration");
  React.useEffect(() => {
    if (
      localStorage.getItem("access") &&
      localStorage.getItem("refresh") &&
      !isCompleteProfile // TODO: Remove this condition and handle it in a better way
    ) {
      navigate(PROTECTED_ROUTES.CLIENTS);
    }
  }, [navigate, isCompleteProfile]);
  return <AnimationWrapper>{children}</AnimationWrapper>;
}
